import Twig from 'twig';
import Scrollbar from './scrollbar.js';
import Media from './../mediaDetect.js'; //Детектор медиа
import './../libs/datepicker-en.js'; // Английская локализация
import './../libs/datepicker-ru.js'; // Русская локализация

/*
 * Компонент календарь - попап с выбором даты от и до,
 * создает событие change:calendar,
 * которое содержат объект CalendarFilter = {
    dateStart: '', // от даты
    dateFinish: '' // до даты
 }
*/

let langId = window.langId;
let CalendarFilter = {
    dateStart: '', // глобальная дата, которая передаётся в качестве параметра фильтрации
    dateFinish: '' // глобальная дата, которая передаётся в качестве параметра фильтрации
}

let hiddenDateStart = '', // вспомогательная дата, хранящая текущее значение календаря
    hiddenDateFinish = ''; // вспомогательная дата, хранящая текущее значение календаря

let Calendar = {
    initTabs: function(currTab, tabs){
        if(!currTab.hasClass('active')) {

            // Отображение активного таба
            tabs.removeClass('active');
            currTab.addClass('active');

            let typeTab = currTab.data('tab-calendar-filter'),
                currDate = new Date(),
                containerTabs = tabs.closest('[data-nav-tab-calendar]'),
                direction = (!!containerTabs.data('nav-tab-calendar-maxdate') ? 'maxDate' : 'minDate');

            // По клику на одном из табов рассчитываем начальную и конечную даты,
            // вызываем функцию устанавливающую эти даты
            // (в календаре, скрытых инпутах, в интервале значений)
            switch(typeTab) {
                case 'today':
                    Calendar.setDateDatepicker(currDate, currDate);
                    break;

                case 'week':
                    let week = new Date();

                    if (direction == 'minDate'){
                        week.setDate(currDate.getDate() + 6);
                        Calendar.setDateDatepicker(currDate, week);
                    } else {
                        week.setDate(currDate.getDate() - 6);
                        Calendar.setDateDatepicker(week, currDate);
                    }
                    break;

                case 'month':
                    let month = new Date();

                    if (direction == 'minDate'){
                        month.setMonth(currDate.getMonth() + 1, currDate.getDate() - 1);
                        Calendar.setDateDatepicker(currDate, month);
                    } else {
                        month.setMonth(currDate.getMonth() - 1, currDate.getDate() + 1);
                        Calendar.setDateDatepicker(month, currDate);
                    }
                    break;

                case 'year':
                    let year = new Date();

                    if (direction == 'minDate'){
                        year.setFullYear(currDate.getFullYear() + 1, currDate.getMonth(), currDate.getDate() - 1);
                        Calendar.setDateDatepicker(currDate, year);
                    } else {
                        year.setFullYear(currDate.getFullYear() - 1, currDate.getMonth(), currDate.getDate() + 1);
                        Calendar.setDateDatepicker(year, currDate);
                    }
                    break;

                case 'half-year':
                    let halfYear = new Date();

                    if (direction == 'minDate'){
                        halfYear.setMonth(currDate.getMonth() + 6, currDate.getDate() - 1);
                        Calendar.setDateDatepicker(currDate, halfYear);
                    } else {
                        halfYear.setMonth(currDate.getMonth() - 6, currDate.getDate() + 1);
                        Calendar.setDateDatepicker(halfYear, currDate);
                    }
                    break;

                default:
                    break;
            }
        }
    },
    initCalendar: function(calendar){
        var optionMinDate = null,
            optionMaxDate = null;

        if (!!calendar.data('datepicker-calendar-mindate')) {
            optionMinDate = calendar.data('datepicker-calendar-mindate');
        }
        if (!!calendar.data('datepicker-calendar-maxdate')) {
            optionMaxDate = calendar.data('datepicker-calendar-maxdate');
        }

        calendar.datepicker({
            dateFormat: 'dd.mm.yy',
            changeMonth: false,
            changeYear: false,
            firstDay: 1,
            isRTL: false,
            numberOfMonths: 2,
            yearSuffix: '',
            minDate: optionMinDate,
            maxDate: optionMaxDate,
            range: 'period', // возможные значения: period, multiple
            range_multiple_max: 2, // максимальное число выбранных дат в режиме "Несколько дат"
            onSelect: function(date, inst, extensionRange) {

                if(hiddenDateStart) {
                    var oldStartDate = new Date(hiddenDateStart).getTime(),
                        newStartDate = new Date(calendar.datepicker("getDate")).getTime();

                    if(oldStartDate > newStartDate) {
                        extensionRange.step = 1;
                        extensionRange.endDate = extensionRange.startDate;
                        extensionRange.endDateText = extensionRange.startDateText;
                    }
                }

                Calendar.setDateDatepicker(extensionRange.startDate, extensionRange.endDate, true);
            }
        });
    },
    setDateDatepicker: function(startDate, finishDate, noSetValueDatepicker){
        // Устанавливает в календаре переданные значения дат startDate и finishDate
        // и обновляет интервал дат внутри попапа
        let calendar = $('[data-datepicker-calendar]'),
            htmlStartDate = startDate.toLocaleDateString(langId, {year: 'numeric', month: 'long', day: 'numeric' }),
            htmlFinishDate = finishDate.toLocaleDateString(langId, {year: 'numeric', month: 'long', day: 'numeric' });

        hiddenDateStart = startDate;
        hiddenDateFinish = finishDate;

        if(!noSetValueDatepicker) {
            calendar.datepicker('setDate', [startDate, finishDate]);
        }

        $('[data-select-interval-date-calendar-filter]').html(htmlStartDate + ' - ' + htmlFinishDate);
    },
    setGlobalDate: function(){
        // Устанавливает глобальные даты календаря фильтра CalendarFilter.dateStart и CalendarFilter.dateFinish
        // и отображает интервал дат в списке
        let htmlStartDate = hiddenDateStart.toLocaleDateString(langId, {year: 'numeric', month: 'long', day: 'numeric' }),
            htmlFinishDate = hiddenDateFinish.toLocaleDateString(langId, {year: 'numeric', month: 'long', day: 'numeric' });

        CalendarFilter.dateStart = hiddenDateStart;
        CalendarFilter.dateFinish = hiddenDateFinish;

        $('[data-interval-date-calendar-filter]').addClass('active').html(htmlStartDate + ' - ' + htmlFinishDate);
        $('[data-content-calendar]').addClass('filter');
    },
    resetSelectDatepicker: function(){
        // Сбрасывает установки календаря, до исходных настроек
        if((CalendarFilter.dateStart != '') && (CalendarFilter.dateFinish != '')) {
            Calendar.setDateDatepicker(CalendarFilter.dateStart, CalendarFilter.dateFinish);
        }else {
            Calendar.setDateDatepicker(new Date(), new Date(), false);
            $('[data-content-popup-calendar-filter]').find('.select-interval').removeClass('select-interval');
        }
    },
    clearCalendar: function(){
        CalendarFilter.dateStart = '';
        CalendarFilter.dateFinish = '';
        Calendar.resetSelectDatepicker();
        $('[data-interval-date-calendar-filter]').removeClass('active');

        setTimeout(function() {
            $(window).trigger('change:calendar', CalendarFilter);
        }, 0);
    },
    getCalendarFilter: function(){
        return CalendarFilter;
    },
    ScrollTabs: {
        // плагин iScroll
        setArrow: function(myScrollCalendarTab, left, right){
            if (myScrollCalendarTab.x == 0) {
                left.hide();
            } else if (myScrollCalendarTab.x < 0) {
                left.show();
            }
            if (myScrollCalendarTab.x == myScrollCalendarTab.maxScrollX) {
                right.hide();
            } else if (myScrollCalendarTab.x > myScrollCalendarTab.maxScrollX) {
                right.show();
            }
        },
        updateScrollContent: function(myScrollCalendarTab) {
            setTimeout(function () {
                var $wrapper = $(myScrollCalendarTab.wrapper),
                    $left = $wrapper.find('.scroll-left'),
                    $right = $wrapper.find('.scroll-right'),
                    $tabContent = $wrapper.find('.scroll-content');

                $tabContent.css('min-width', Calendar.ScrollTabs.minWidthTabs($wrapper) + 'px');

                myScrollCalendarTab.refresh();
                Calendar.ScrollTabs.setArrow(myScrollCalendarTab, $left, $right);
            }, 0);
        },
        initScrollContent: function(elem, myScrollCalendarTab) {
            myScrollCalendarTab = new IScroll(elem, {
                eventPassthrough: true,
                scrollX: true,
                scrollY: false,
                preventDefault: false,
                scrollbars: 'custom'
            });

            var $scroller = $(elem).find('.scroll-content'),
                $left = $(elem).find('.scroll-left'),
                $right = $(elem).find('.scroll-right');

            Calendar.ScrollTabs.setArrow(myScrollCalendarTab, $left, $right);

            $left.on('click', function(){
                var step_scroll = (Math.abs(myScrollCalendarTab.maxScrollX)/2 < 100 ? Math.abs(myScrollCalendarTab.maxScrollX) : Math.abs(myScrollCalendarTab.maxScrollX)/2 + 10),
                    x = (Math.abs(myScrollCalendarTab.x) > step_scroll ? step_scroll : Math.abs(myScrollCalendarTab.x));

                myScrollCalendarTab.scrollBy(x, 0, parseInt(x/10));
            });

            $right.on('click', function(){
                var step_scroll = (Math.abs(myScrollCalendarTab.maxScrollX)/2 < 100 ? Math.abs(myScrollCalendarTab.maxScrollX) : Math.abs(myScrollCalendarTab.maxScrollX)/2 + 10),
                    x_max = Math.abs(myScrollCalendarTab.maxScrollX) - Math.abs(myScrollCalendarTab.x),
                    x = (x_max < step_scroll ? x_max : step_scroll);

                myScrollCalendarTab.scrollBy(-1*x, 0, parseInt(x/10));
            });

            myScrollCalendarTab.on('scrollEnd', function() {
                Calendar.ScrollTabs.setArrow(this, $left, $right);
            });

            $(window).on('resize', function(){
                Calendar.ScrollTabs.updateScrollContent(myScrollCalendarTab);
            });
        },
        minWidthTabs: function(tabsNav){
            // Определяем минимальную ширину текущей навигации таба
            var minWidth = 0;
            tabsNav.find('[data-tab-calendar-filter]').each(function(index, value){
                minWidth += $(this).outerWidth(true);
            });

            return minWidth;
        }
    },
    ajaxFilter: function() {
        //initial trigger change:calendar
        setTimeout(function() {
            $(window).trigger('change:calendar', CalendarFilter);
        }, 0);
    },
    Popup: {
        init: function(popupCalendar){
            $('[data-btn-dates-calendar-filter]').on('click', function(e){
                e.preventDefault();

                // Устанавливаем глобальные даты фильтрации календаря и обновляем список мероприятий
                Calendar.setGlobalDate();

                $('[data-clear-filter-calendar]').addClass('show');
                Calendar.ajaxFilter();
                Calendar.Popup.close(popupCalendar);
            });

            // Переключение состояния попапа по клику на кнопку
            $('[data-toogle-popup-calendar-filter]').on('click', function(){
                Calendar.Popup.toggle(popupCalendar);
            });

            // Закрытие попапа по клику на кнопку
            $('[data-close-popup-calendar-filter]').on('click', function(){
                Calendar.Popup.close(popupCalendar);

                setTimeout(function(){
                    Calendar.resetSelectDatepicker();
                }, 350);
            });

            // Отлавливаем событие клика вне попапа, вне кнопки открыть/закрыть попап,
            // вне табов переключения дат и при его выполнении закрываем попап
            $(document).on('click', function(event){
                let _target = $(event.target);

                if( _target.closest('[data-inner-popup-calendar-filter]').length ||
                    _target.closest('[data-toogle-popup-calendar-filter]').length ||
                    _target.closest('[data-close-popup-calendar-filter]').length ||
                    _target.closest('[data-popup]').length ||
                    _target.closest('[data-btn-subscription-footer]').length||
                    _target.closest('[data-handler="prev"].ui-datepicker-prev')||
                    _target.closest('[data-handler="next"].ui-datepicker-next')) {
                    return;
                }
                event.stopPropagation();
                Calendar.Popup.close(popupCalendar);

                setTimeout(function(){
                     Calendar.resetSelectDatepicker();
                }, 350);
            });

            $(window).resize(function (event) {

                if (Calendar.Popup.isOpen()) {
                    if (Scrollbar.isActive()) {
                        $('body').css('padding-right', Scrollbar.getWidth() + 'px');
                    } else {
                        $('body').removeAttr('style');
                    }

                    if(Media.detect().isMobile){
                        $('body').removeClass('page_overflow');
                    }else{
                        $('body').addClass('page_overflow');
                    }
                }
            });
        },
        open: function(popupCalendar){

            if(!Media.detect().isMobile){
                $('body').addClass('page_overflow');
            }

            $('body').addClass('page_calendar-popup-open');

            if (Scrollbar.isActive()) {
                $('body').css('padding-right', Scrollbar.getWidth() + 'px');
            }

            popupCalendar.addClass('open').animate({
                opacity: 1
            }, 300, function(){});

            // Инициализируем скролл табов
            let tabNavCalendar = $('[data-nav-tab-calendar]');
            if(tabNavCalendar.length) {

                let myScrollCalendarTab;

                if (!(tabNavCalendar.find('.scroll-content').length) ){
                    // Добавляем внутреннюю обертку скроллящейся части
                    tabNavCalendar.wrapInner('<div class="scroll-content"></div>');
                    // Добавляем стрелки вперёд-назад
                    tabNavCalendar.append('<div class="scroll-left"></div><div class="scroll-right"></div>');

                    tabNavCalendar.find('.scroll-content').css('min-width', Calendar.ScrollTabs.minWidthTabs(tabNavCalendar) + 'px');
                }

                Calendar.ScrollTabs.initScrollContent('[data-nav-tab-calendar]', myScrollCalendarTab);
            }
        },
        close: function(popupCalendar){
            popupCalendar.animate({ opacity: 0 }, 300, function(){
                $(this).removeClass('open');
                $('body')
                    .removeClass('page_overflow')
                    .removeClass('page_calendar-popup-open')
                    .removeAttr('style');

                $('[data-nav-tab-calendar]').find('[data-tab-calendar-filter]').removeClass('active');
            });
        },
        toggle: function(popupCalendar){
            if(popupCalendar.hasClass('open')) {
                Calendar.Popup.close(popupCalendar);
            }else{
                Calendar.Popup.open(popupCalendar);
            }
        },
        isOpen: function () {
            return $('body').hasClass('page_calendar-popup-open');
        }
    }
}

$(document).ready(function($) {
    if($('[data-datepicker-calendar]').length) {
        $.datepicker.setDefaults( $.datepicker.regional[langId] );
    }

    // Инициализируем табы
    let tabCalendar = $('[data-tab-calendar-filter]');
    if(tabCalendar.length) {

        tabCalendar.on('click', function(e){
            e.preventDefault();
            Calendar.initTabs($(this), tabCalendar);
        });
    }

    // Инициализируем календари
    let datepickerCalendars = $('[data-datepicker-calendar]');
    if(datepickerCalendars.length) {
        var dataDateStartCalendar = datepickerCalendars.data('loaddate-start'),
            dataDateFinishCalendar = datepickerCalendars.data('loaddate-finish');

        Calendar.initCalendar(datepickerCalendars);

        // Устанавливаем изначально в календаре текущую дату
        hiddenDateStart = new Date();
        hiddenDateFinish = new Date();

        Calendar.setDateDatepicker(hiddenDateStart, hiddenDateFinish);

        // Устанавливаем уже выбранные даты из кэша
        if((dataDateStartCalendar != '') && (dataDateFinishCalendar != '')) {
            let loadStartCalendar = $.datepicker.parseDate( "dd.mm.yy", dataDateStartCalendar),
                loadFinishCalendar = $.datepicker.parseDate( "dd.mm.yy", dataDateFinishCalendar);

            hiddenDateStart = loadStartCalendar;
            hiddenDateFinish = loadFinishCalendar;

            // Устанавливаем в календаре уже выбранные даты из кэша
            Calendar.setDateDatepicker(loadStartCalendar, loadFinishCalendar);
            // Устанавливаем глобальные даты календаря
            Calendar.setGlobalDate();
            //Calendar.ajaxFilter();
        }

        datepickerCalendars
            .on('mouseenter', 'tbody td:not(.ui-state-disabled)', function(){
                var $this = $(this),
                    extensionRange = datepickerCalendars.datepicker('widget').data('datepickerExtensionRange'),
                    msDateStart = new Date(extensionRange.startDate).getTime(),
                    msDateEnd = new Date(extensionRange.endDate).getTime(),
                    hoverDate = new Date($this.data('year'), $this.data('month'), $this.find('span, a').text());

                if(msDateStart == msDateEnd){
                    datepickerCalendars.find('tbody td:not(.ui-state-disabled)').each(function(index, el) {
                        var $currEl = $(this),
                            currDate = new Date($currEl.data('year'), $currEl.data('month'), $currEl.find('span, a').text());

                        if (currDate.getTime() > msDateStart && currDate.getTime() < hoverDate.getTime() && (extensionRange.step == 1)) {
                            $currEl.addClass('hover-interval');
                        }else{
                            $currEl.removeClass('hover-interval');
                        };
                    });

                    var $popupInterval = $('[data-select-interval-date-calendar-filter]'),
                        htmlStartDate = hiddenDateStart.toLocaleDateString(langId, {year: 'numeric', month: 'long', day: 'numeric' }),
                        htmlFinishDate = hoverDate.toLocaleDateString(langId, {year: 'numeric', month: 'long', day: 'numeric' });;

                    if((extensionRange.step == 1) && (hoverDate.getTime() > msDateStart)) {
                        $popupInterval.html(htmlStartDate + ' - ' + htmlFinishDate);
                    }else{
                        $popupInterval.html(htmlStartDate + ' - ' + htmlStartDate);
                    }
                }
            })
            .on('mouseleave', 'tbody td:not(.ui-state-disabled)', function(){
                var extensionRange = datepickerCalendars.datepicker('widget').data('datepickerExtensionRange'),
                    dateStart = new Date(extensionRange.startDate).getTime(),
                    htmlStartDate = hiddenDateStart.toLocaleDateString(langId, {year: 'numeric', month: 'long', day: 'numeric' }),
                    htmlFinishDate = hiddenDateFinish.toLocaleDateString(langId, {year: 'numeric', month: 'long', day: 'numeric' });

                datepickerCalendars.find('tbody td').removeClass('hover-interval');

                if(extensionRange.step == 0) {
                    $('[data-select-interval-date-calendar-filter]').html(htmlStartDate + ' - ' + htmlFinishDate);
                }else{
                    $('[data-select-interval-date-calendar-filter]').html(htmlStartDate + ' - ' + htmlStartDate);
                }
            });
    }

    // Инициализируем настройки попапа
    let popupCalendar = $('[data-popup-calendar-filter]');
    if(popupCalendar.length) {
        Calendar.Popup.init(popupCalendar);
    }

    // Обработка кнопки очищения фильтра
    let btnClearFilterCalendar = $('[data-clear-filter-calendar]')
    btnClearFilterCalendar.on('click', function(){
        Calendar.clearCalendar();
        $('[data-clear-filter-calendar]').removeClass('show');
    });

});

export default {
    setGlobalDate: Calendar.setGlobalDate,
    clearCalendar: Calendar.clearCalendar,
    setDateDatepicker: Calendar.setDateDatepicker,
    getCalendarFilter: Calendar.getCalendarFilter
};


// WEBPACK FOOTER //
// ./components/calendar.js